export const comments_4180335 = {"data":{"data":[],"links":{}}}